exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-24917a3a]{position:relative;display:flex;align-items:center;justify-content:space-between;padding:1rem 2rem;font-size:1.6rem}.button[data-v-24917a3a]:hover{background:unset;color:#00b4ff}.button__arrow[data-v-24917a3a]{width:10px;height:11px}.list[data-v-24917a3a]{display:flex;flex-direction:column;align-items:flex-start}.item[data-v-24917a3a]{cursor:pointer}", ""]);

// exports
